<template>
  <FixedLayout
    ref="fixed_layout_element"
    left_content_class="settings-menu">
      <template #left-content>
          <SettingsMenu
            :webmail_view="webmail_view"
          />
      </template>

      <template #right-content>
          <UserDashboard v-if="route.name === 'settings'"/>
          <router-view></router-view>
      </template>
  </FixedLayout>
</template>

<script setup>
  import {useRoute, useRouter}      from 'vue-router';
  import {ref, watch, defineProps}  from 'vue';
  import {onMounted}                from 'vue';
  import FixedLayout                from '@/vue/Layouts/FixedLayout.vue';
  import SettingsMenu               from '@/vue/Views/Settings/Shared/SettingsMenu.vue';
  import UserDashboard              from '@/vue/Views/Webmail/Sections/UserDashboard.vue';
  import LayoutSettingsController   from '@/js/Webmail/LayoutSettingsController';
  import MetadataController         from '@/js/Webmail/MetadataController';
  import KidsController             from '@/js/Settings/Kids/KidsController';

  const props = defineProps({
    webmail_view: {},
  })

  const route                = useRoute();
  const fixed_layout_element = ref();
  const kids_controller      = KidsController;
  const router               = useRouter();

  watch(() => LayoutSettingsController.state_indicator, () => {
    setMobileContentVisibility();
  });

  watch(() => route.name, () => {
    setMobileContentVisibility();
  });

  onMounted(() => {
    checkAndRedirectKidsAuth();
    setMobileContentVisibility();
    MetadataController.setPageTitle("settings.title");
  });

  const checkAndRedirectKidsAuth = () => {
    if(!kids_controller.data.is_kid_account || kids_controller.data.parent_authenticated){
      return;
    }

    router.push('kids_auth');
  }

  const setMobileContentVisibility = () => {
    let visibility = (LayoutSettingsController.state_indicator === 'mobile' && route.name === 'settings')
                   ? false
                   : true;

    fixed_layout_element.value.setRightCollumnVisibility(visibility);
  }
</script>
